"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_SCREEN_SHARES = void 0;
var MAX_SCREEN_SHARES = exports.MAX_SCREEN_SHARES = 2;